module.exports = __webpack_public_path__ + "img/ua.ce258373.svg";